import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';

//import icons
import loadingGif from '../assets/loading.svg';

const LoadingIndicator = ({ clang }) => {
    return (
        <div className="loader">
            <img src={loadingGif} alt={lang[clang].loading_gif} className="loader--img"/>
        </div>
    );
};

LoadingIndicator.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(LoadingIndicator);



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.js